import React, { Component } from 'react';
import {
	Carousel,
	CarouselItem,
	CarouselIndicators,
	Row, Col, Container,
} from 'reactstrap';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const items = [
	{
		src: '/static/images/meet-your-match/Pragya-testimonial.jpg',
		name: 'Pragya Batra, CEO Quirksmith',
		quote: 'Within 10 days of starting the monthly giving program, I received the details about the specific person whose life was impacted through my donation. The monthly invoices come automatically, so there is no further follow up required. ',
		donorname: 'Pragya',
		givequote: 'Pragya Batra has been supporting the daily nutritional needs of an abandoned senior citizen',
		key: 0,
		beneficiaries: [
			{
				name: 'Shobhana Dhotre',
				gender: 'Female',
				age: '76',
				location: 'Mumbai',
				src1: '/static/images/beneficiary/ShobhanaDhotre_DignityFoundation_1.jpg',
			},

		],
	},
	{
		src: '/static/images/meet-your-match/Lakshman-testimonial.jpg',
		name: 'Lakshman Pasala, Entrepreneur',
		quote: 'It felt great to receive the photographs of the children that I am supporting. It is a humbling feeling to be able to give them a future that they deserve. GiveIndia’s transparent and credible way of operations gives me the confidence to donate through them.',
		donorname: 'Lakshman',
		givequote: 'Lakshman Pasala has been supporting the education of two underprivileged children',
		key: 1,
		beneficiaries: [
			{
				name: 'Kumari Arvi',
				gender: 'Female',
				age: '4',
				location: 'Uttar Pradesh',
				src1: '/static/images/beneficiary/KumariArvi_Psycho_1.jpg',
			},

		],
	},
];

export default class TestimonialPanel extends Component {
	constructor(props) {
		super(props);
		this.state = { activeIndex: 0 };

		this.goToIndex = this.goToIndex.bind(this);
		this.onExiting = this.onExiting.bind(this);
		this.onExited = this.onExited.bind(this);
	}


	componentDidMount() {
		setInterval(() => {
			this.setState({
				activeIndex: this.state.activeIndex === 3 ? 0 : this.state.activeIndex++,
			});
		}, 1000);
	}

	onExiting() {
		this.animating = true;
	}

	onExited() {
		this.animating = false;
	}

	goToIndex(newIndex) {
		if (this.animating) return;
		this.setState({ activeIndex: newIndex });
	}

	getBeneficiaries(beneficiaries) {
		return beneficiaries.map(beneficiary => (<Row style={{ paddingBottom: '1rem' }}>
			<div md={4} lg={6} sm={12} xs={12}>
				<img className="matching-beneficiaries" src={`${config.cdnUrl}${beneficiary.src1}`} alt="beneficiaries-image" />
			</div>
			<div md={4} lg={6} sm={12} xs={12}>
				<p className="matching-carousel-beneficiaries-name">{beneficiary.name}</p>
				<p className="matching-carousel-beneficiaries-details">{beneficiary.gender} | {beneficiary.age} yrs old</p>
				<p>
					<img className="beneficiaries-location-icon" src={`${config.cdnUrl}/static/images/mail/location-pin.png`} />
					<span className="beneficiaries-location">{beneficiary.location}</span>
				</p>
			</div>
                                           </Row>));
	}

	render() {
		const { activeIndex } = this.state;
		const { width } = this.props;
		const slides = items.map(item => (
			<CarouselItem
				onExiting={this.onExiting}
				onExited={this.onExited}
				key={item.src}
				children={
					[<Container className="carousel-item d-flex">
						<Row className="carousel-body d-flex" style={{ paddingTop: '25px', paddingBottom: '25px' }}>
							<Col className="img-container d-flex justify-content-center" md={2} lg={2} sm={12} xs={12}>
								<img className="volunteer-img" src={`${config.cdnUrl}${item.src}`} alt="testimonial-image" />
							</Col>
							<Col className="d-flex f-d-col justify-content-center" md={6} lg={6} sm={12} xs={12}>
								<p className="hide-for-mobile">{item.givequote}</p>
								<Row>
									<p>"{item.quote}"</p>
								</Row>
								<Row className="d-flex  hide-for-mobile">
									<h3>{item.name}</h3>
								</Row>
								<Row className="hide-for-desktop hide-for-mobile">
									<h4>{item.name}</h4>
								</Row>
							</Col>
							<Col className="d-flex f-d-col  " md={4} lg={4} sm={12} xs={12}>
								<div className="hide-for-mobile">
									<h3>Beneficiaries supported by {item.donorname} </h3>
									{this.getBeneficiaries(item.beneficiaries)}
								</div>
							</Col>
						</Row>
					</Container>]
				}
			/>
		));

		return (
			<Carousel className="carousel-container w-100" activeIndex={activeIndex} ride="carousel" autoPlay>
				{slides}
				<CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={this.goToIndex} />

				<style global jsx>
					{
						`
						.matching-carousel-beneficiaries-name{
							font-size: 20px;
							color: #ff5050;
							line-height: 14px!important;
							padding-left: 10px;
						}
						.matching-carousel-beneficiaries-details{
							line-height: 0px!important;
								padding-left: 10px;
						}
						.beneficiaries-location{
							padding-left: 10px;
								color:#555555 !important;
						}
						.beneficiaries-location-icon{
								padding-left: 10px;
							width: 23px !important;
							height: 18px !important;
							color:#555555 !important;
							display: inline !important;
						}

						.matching-beneficiaries{
						height: 80px!important;
					width: 80px!important;
						}
						@media (max-width: 596px) {
							.images-beneficiaries {
								height: 140px!important;
							   padding-left: 20px;
								 padding-top: 15px;
								 padding-right: 20px;

							}
						}

						.volunteer-img {
							border: 1px solid transperant rgba(0, 0, 0, 0.1);
							border-radius: 50%;
							height: 100px !important;
							width: 100px !important;
						}

						.carousel-indicators li {
							background-color: #999 !important;
							width: 0.5rem !important;
							border: 1px solid transparent;
							border-radius: 50%;
							height: 0.5rem !important;
						}

						.carousel-indicators .active {
							background-color: #666 !important;
						}

						.carousel-indicators {
							bottom: 0px;
							margin-bottom: 10px;
							margin-top: 10px;
						}

						@media(max-width: 767px) {
							.carousel-body {
								padding: 25px 0px;
							}

							.img-container {
								margin-bottom: 1rem;
							}
						}
				`

					}
				</style>
			</Carousel>
		);
	}
}
